// src/i18n/es/errorMonitor.ts

const errorMonitor = {
  name: 'Monitor de Errores',
  title: 'Monitor de Errores',
  subtitle: 'Seguimiento y análisis de errores en tiempo real',
  filters: {
    group: 'Grupo',
    allGroups: 'Todos los Grupos',
    hotel: 'Instalación',
    allHotels: 'Todas las Instalaciones',
    device: 'Dispositivo',
    allDevices: 'Todos los Dispositivos',
    dateFrom: 'Fecha Desde',
    dateTo: 'Fecha Hasta',
    severity: 'Severidad',
    allSeverities: 'Todas las Severidades',
    category: 'Categoría',
    allCategories: 'Todas las Categorías',
    nature: 'Naturaleza',
    allNatures: 'Todas',
    errorCode: 'Código de Error',
  },
  stats: {
    totalErrors: 'Total de Errores',
    genericErrors: 'Errores Genéricos',
    keyDispenserErrors: 'Errores de Dispensador',
    paymentErrors: 'Errores de Pago',
  },
  trendTitle: 'Tendencias de Errores',
  trendSubtitle: 'Patrones de errores en el tiempo',
  chart: {
    errors: 'Errores',
  },
  errorsByDevice: 'Errores por Dispositivo',
  recentErrors: 'Errores Recientes',
  recentErrorsSubtitle: 'Últimos eventos de error',
  views: {
    list: 'Lista',
    byDevice: 'Por Dispositivo',
  },
  table: {
    timestamp: 'Marca de Tiempo',
    device: 'Dispositivo',
    group: 'Grupo',
    hotel: 'Instalación',
    type: 'Tipo',
    errors: 'Errores',
    lastError: 'Último Error',
    category: 'Categoría',
    severity: 'Severidad',
    nature: 'Naturaleza',
    errorCode: 'Código de Error',
    error: 'Error',
    description: 'Descripción',
    recommendation: 'Recomendación',
    reference: 'Referencia',
    reservation: 'Reserva',
    room: 'Habitación',
    metadata: 'Metadata',
    context: 'Contexto',
    walkInGuest: 'Huésped walk-in',
    checkInSource: 'Origen del check-in',
    journeyInfo: 'Información del Journey',
    journeyStatus: 'Estado',
    journeyEvents: 'Total de eventos',
    journeyErrors: 'Errores en el journey',
    multipleErrorsInJourney: '%{count} error en este trayecto |||| %{count} errores en este trayecto',
  },
  noErrors: 'No se encontraron errores',
  noData: 'No hay datos disponibles',
  errors: {
    loadFailed: 'Error al cargar las estadísticas de errores',
    loadEventsFailed: 'Error al cargar los eventos de error',
  },
  help: {
    page: 'Monitoriza los errores que ocurren en kioscos y dispensadores. Visualiza la lista completa de errores o agrupa por dispositivo para identificar equipos problemáticos.',
  },

  // Bulk delete (SuperAdmin)
  bulkDelete: {
    deleteSelected: 'Eliminar seleccionados',
    deleteByFilters: 'Eliminar todos según filtros',
    confirmTitle: 'Confirmar eliminación',
    confirmMessage: 'Está a punto de eliminar permanentemente %{count} error. Esta acción no se puede deshacer. |||| Está a punto de eliminar permanentemente %{count} errores. Esta acción no se puede deshacer.',
    confirmByFiltersMessage: 'Está a punto de eliminar permanentemente TODOS los errores que coinciden con los filtros actuales. Esta acción no se puede deshacer.',
    irreversible: 'Esta acción es irreversible. Los errores eliminados no se pueden recuperar.',
    deleting: 'Eliminando...',
    successMessage: '%{count} error eliminado correctamente |||| %{count} errores eliminados correctamente',
    errorMessage: 'Error al eliminar errores',
    selected: '%{count} seleccionado |||| %{count} seleccionados',
    clearSelection: 'Limpiar selección',
    selectAll: 'Seleccionar todos',
  },

  nature: {
    error: 'Error',
    operational: 'Operacional',
    informational: 'Informativo',
  },

  errorTypes: {
    generic: {
      name: 'Error Genérico',
      description: 'Error general del sistema',
    },
    keyDispenser: {
      name: 'Error de Dispensador',
      description: 'Mal funcionamiento del dispensador de llaves',
    },
    payment: {
      name: 'Error de Pago',
      description: 'Fallo en el procesamiento del pago',
    },
    unknown: {
      name: 'Error Desconocido',
      description: 'Tipo de error desconocido',
    },
  },
  
  sections: {
    s: {
      name: 'Búsqueda',
      description: 'Búsqueda de reserva',
    },
    r: {
      name: 'Selección de Habitación',
      description: 'Elegir habitación para walk-in',
    },
    i: {
      name: 'Identificación',
      description: 'Información del huésped',
    },
    f: {
      name: 'Firma',
      description: 'Firmar formulario de registro',
    },
    u: {
      name: 'Ventas Adicionales',
      description: 'Servicios adicionales',
    },
    p: {
      name: 'Pago',
      description: 'Procesar pago',
    },
    k: {
      name: 'Entrega de Llave',
      description: 'Dispensar llave de habitación',
    },
    unknown: {
      name: 'Desconocido',
      description: 'Sección desconocida',
    },
  },
  
  errorMonitor: {
    title: 'Monitor de Errores',
    subtitle: 'Seguimiento y análisis de errores en tiempo real',
    filters: {
      hotel: 'Instalación',
      allHotels: 'Todas las Instalaciones',
      dateFrom: 'Fecha Desde',
      dateTo: 'Fecha Hasta',
    },
    stats: {
      totalErrors: 'Total de Errores',
      genericErrors: 'Errores Genéricos',
      keyDispenserErrors: 'Errores de Dispensador',
      paymentErrors: 'Errores de Pago',
    },
    trendTitle: 'Tendencias de Errores',
    trendSubtitle: 'Patrones de errores en el tiempo',
    chart: {
      errors: 'Errores',
    },
    errorsByDevice: 'Errores por Dispositivo',
    recentErrors: 'Errores Recientes',
    recentErrorsSubtitle: 'Últimos eventos de error',
    table: {
      timestamp: 'Marca de Tiempo',
      device: 'Dispositivo',
      type: 'Tipo',
      errors: 'Errores',
      lastError: 'Último Error',
      errorType: 'Tipo de Error',
      section: 'Sección',
      errorCode: 'Código de Error',
      reservation: 'Reserva',
      room: 'Habitación',
      context: 'Contexto',
      walkInGuest: 'Huésped walk-in',
      checkInSource: 'Origen del check-in',
    },
    noErrors: 'No se encontraron errores',
    errors: {
      loadFailed: 'Error al cargar las estadísticas de errores',
      loadEventsFailed: 'Error al cargar los eventos de error',
    },
  },

  abandonmentAnalysis: {
    title: 'Análisis de Abandonos',
    subtitle: 'Comprenda dónde los huéspedes abandonan el proceso de check-in',
    filters: {
      hotel: 'Instalación',
      allHotels: 'Todas las Instalaciones',
      dateFrom: 'Fecha Desde',
      dateTo: 'Fecha Hasta',
    },
    summary: {
      totalAbandonments: 'Total de Abandonos',
      totalCheckIns: 'Total de Check-ins',
      abandonmentRate: 'Tasa de Abandono',
    },
    funnelTitle: 'Abandonos por Sección',
    funnelSubtitle: 'Dónde los huéspedes abandonan el proceso',
    avgDuration: 'Tiempo promedio en sección',
    noData: 'No hay datos de abandonos disponibles',
    byHourTitle: 'Abandonos por Hora',
    byHourSubtitle: 'Patrones de abandono por hora',
    byDeviceTitle: 'Abandonos por Dispositivo',
    byDeviceSubtitle: 'Tasas de abandono por dispositivo',
    chart: {
      abandonments: 'Abandonos',
      checkIns: 'Check-ins',
      rate: 'Tasa',
    },
    legend: {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      critical: 'Crítica',
    },
    table: {
      device: 'Dispositivo',
      abandonments: 'Abandonos',
      checkIns: 'Check-ins',
      rate: 'Tasa',
      visualization: 'Visualización',
      note: 'Nota',
      sortedByRate: 'Los dispositivos están ordenados por tasa de abandono (mayor primero)',
    },
    errors: {
      loadFailed: 'Error al cargar el análisis de abandonos',
    },
  },
};

export default errorMonitor;
